<template>
  <div id="menu">
    <nav ref="menu_v">
      <ul>
        <li @click="switch_menu(0)" :class="{ active: menu == 0 }">
          <div class="icon">
            <img src="@/assets/images/menu/e-book.svg" alt="icon" />
          </div>
          <h5>
            <span class="cn">教學電子書</span>
            <span class="en">E-Books</span>
          </h5>
        </li>
        <li @click="switch_menu(1)" :class="{ active: menu == 1 }">
          <div class="icon">
            <img src="@/assets/images/menu/resources.svg" alt="icon" />
          </div>
          <h5>
            <span class="cn">教學資源</span>
            <span class="en">Resources</span>
          </h5>
        </li>
        <li @click="switch_menu(2)" :class="{ active: menu == 2 }">
          <div class="icon">
            <img src="@/assets/images/menu/multi-media.svg" alt="icon" />
          </div>
          <h5>
            <span class="cn">多媒體</span>
            <span class="en">Multimedia</span>
          </h5>
        </li>
        <li @click="switch_menu(3)" :class="{ active: menu == 3 }">
          <div class="icon">
            <img src="@/assets/images/menu/public-resources.svg" alt="icon" />
          </div>
          <h5>
            <span class="cn">共同資源</span>
            <span class="en">Public resources</span>
          </h5>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { ref, onMounted, defineEmits } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

const menu = ref(0);
const menu_v = ref(null);

const emits = defineEmits(["sub_menu"]);

function switch_menu(data) {
  menu.value = data;
  emits("sub_menu", menu.value);
  localStorage.setItem("menu", data);
}

// function adjustScale(element) {
//   // 獲取當前的縮放比例
//   const currentZoom = window.devicePixelRatio || 1;

//   // 反向縮放，使之看起來像 100%
//   const inverseZoom = 1 / currentZoom;

//   // 使用 CSS transform 來反向縮放
//   element.style.zoom = inverseZoom;

// }

onMounted(() => {
  if (localStorage.getItem("menu")) {
    menu.value = Number(localStorage.getItem("menu"));
  }
  // adjustScale(menu_v.value);
});
</script>
